import {
  SharedComponentImplementationsContext,
  type SharedComponentImplementations
} from '@Pages/pageRuntime/sharedComponentForwarding';
import React from 'react';

export function SharedComponentImplementationsProvider({
  implementations,
  children
}: {
  implementations: SharedComponentImplementations;
  children: React.ReactNode;
}) {
  return (
    <SharedComponentImplementationsContext.Provider value={implementations}>
      {children}
    </SharedComponentImplementationsContext.Provider>
  );
}
